(function () {

  /* === Nav visibility helper === */
  function updateNavVisibility(swiper, prevBtn, nextBtn) {
    var realSlides = swiper.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    var perView   = swiper.currentBreakpoint
      ? (swiper.params.breakpoints[swiper.currentBreakpoint] || {}).slidesPerView || swiper.params.slidesPerView
      : swiper.params.slidesPerView;
    perView = Math.ceil(perView) || 1;
    var hide = realSlides <= perView;
    if (prevBtn) prevBtn.style.display = hide ? 'none' : '';
    if (nextBtn) nextBtn.style.display = hide ? 'none' : '';
  }

  /* === Sliders === */
  function initSliders() {
    if (typeof Swiper === 'undefined') return;

    /* Hero slider */
    document.querySelectorAll('.business-unit__swiper').forEach(function (el) {
      var wrapper = el.closest('.business-unit__slider-section');
      var prevBtn = wrapper.querySelector('.business-unit__nav-btn--prev');
      var nextBtn = wrapper.querySelector('.business-unit__nav-btn--next');

      var swiper = new Swiper(el, {
        slidesPerView: 2,
        spaceBetween: 24,
        loop: true,
        navigation: { prevEl: prevBtn, nextEl: nextBtn },
        pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
        breakpoints: {
          0:   { slidesPerView: 1, spaceBetween: 12 },
          640: { slidesPerView: 2, spaceBetween: 24 },
        },
        on: {
          init:       function (s) { updateNavVisibility(s, prevBtn, nextBtn); },
          breakpoint: function (s) { updateNavVisibility(s, prevBtn, nextBtn); },
        },
      });
    });

    /* Products slider */
    document.querySelectorAll('.business-unit__products-swiper').forEach(function (el) {
      var wrapper = el.closest('.business-unit__products-slider-wrapper');
      var prevBtn = wrapper.querySelector('.business-unit__nav-btn--prev');
      var nextBtn = wrapper.querySelector('.business-unit__nav-btn--next');

      var swiper = new Swiper(el, {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: true,
        navigation: { prevEl: prevBtn, nextEl: nextBtn },
        pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
        breakpoints: {
          0:   { slidesPerView: 1, spaceBetween: 12 },
          640: { slidesPerView: 2, spaceBetween: 16 },
          900: { slidesPerView: 3, spaceBetween: 20 },
        },
        on: {
          init:       function (s) { updateNavVisibility(s, prevBtn, nextBtn); },
          breakpoint: function (s) { updateNavVisibility(s, prevBtn, nextBtn); },
        },
      });
    });

    /* Offers slider */
    document.querySelectorAll('.business-unit__offers-swiper').forEach(function (el) {
      var wrapper = el.closest('.business-unit__offers-slider-wrapper');
      var prevBtn = wrapper.querySelector('.business-unit__nav-btn--prev');
      var nextBtn = wrapper.querySelector('.business-unit__nav-btn--next');

      var swiper = new Swiper(el, {
        slidesPerView: 1,
        loop: true,
        navigation: { prevEl: prevBtn, nextEl: nextBtn },
        pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
        on: {
          init:       function (s) { updateNavVisibility(s, prevBtn, nextBtn); },
          breakpoint: function (s) { updateNavVisibility(s, prevBtn, nextBtn); },
        },
      });
    });
  }

  /* === FAQ Accordion === */
  function initFaq() {
    document.querySelectorAll('.business-unit__faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item     = btn.closest('.business-unit__faq-item');
        var isActive = item.classList.contains('business-unit__faq-item--active');

        // Close all items in the same list
        var list = item.closest('.business-unit__faq-list');
        list.querySelectorAll('.business-unit__faq-item--active').forEach(function (openItem) {
          openItem.classList.remove('business-unit__faq-item--active');
          openItem.querySelector('.business-unit__faq-question').setAttribute('aria-expanded', 'false');
        });

        // Open clicked item if it was closed
        if (!isActive) {
          item.classList.add('business-unit__faq-item--active');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function init() {
    initSliders();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
